'use client';

import { useTheme } from '@emotion/react';
import { useState } from 'react';
import { http } from '../../../lib/api/http';
import { V3 } from '../../../lib/api/urls';
import { activeStatus } from '../../../constants/events';
import { DEVICE_SCREENS_MAX_STRING } from '../../../lib/consts';
import { Container } from '../../../components/layout/Container';
import { BreadCrumbs } from '../../../components/blocks/BreadCrumbs';
import { H1 } from '../../../components/styled/typography';
import { Subscription } from '../../../components/about/Subscription';
import { MobileApps } from '../../../components/about/MobileApps';
import { CompilationCard } from '../../../components/compilations/compilation-card';
import { RedButton } from '../../../components/styled/Button';
import { City, Compilation } from '../../../models';

export function PageComponent({
  currentCity,
  compilations,
}: {
  currentCity: City;
  compilations: { results: Compilation[]; next: string | null };
}) {
  const LIMIT_CARDS = 20;
  const theme = useTheme();
  const [compilationsList, setCompilationsList] = useState(compilations);

  const showMore = () => {
    http
      .get(V3.compilations.root, {
        limit: LIMIT_CARDS,
        offset: compilationsList.results.length,
        is_web: 'true',
        status: activeStatus,
        city: currentCity.id,
      })
      .then((res) => {
        setCompilationsList({
          ...res,
          results: compilationsList.results.concat(res.results),
        });
      });
  };

  return (
    <Container
      css={{
        padding: '16px 12px',
        [DEVICE_SCREENS_MAX_STRING.md]: {
          padding: '28px 8px 0 8px',
        },
      }}
    >
      <BreadCrumbs currentCity={currentCity} items={[{ title: 'Подборки' }]} />
      <H1
        css={{
          fontFamily: 'Montserrat',
          color: theme.colors.text,
          fontWeight: 700,
          fontSize: 32,
          marginTop: 16,
          marginBottom: '4rem',
          [DEVICE_SCREENS_MAX_STRING.md]: {
            marginTop: 12,
            marginBottom: 40,
          },
        }}
      >
        Подборки
      </H1>
      <main css={{ fontFamily: 'Golos', color: theme.colors.black }}>
        <div>
          {compilationsList.results && compilationsList.results.length > 0 && (
            <>
              <div
                css={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr 1fr',
                  gap: 16,
                  [DEVICE_SCREENS_MAX_STRING.md]: {
                    gridTemplateColumns: '1fr 1fr',
                  },
                }}
              >
                {compilationsList.results.map((item) => (
                  <CompilationCard
                    key={`CompilationCard__${item.id}`}
                    item={item}
                    currentCity={currentCity}
                  />
                ))}
              </div>

              <div css={{ padding: '0 8px' }} />
            </>
          )}
          {compilationsList.next && (
            <div
              css={{
                display: 'flex',
                marginTop: 16,
              }}
            >
              <RedButton callback={() => showMore()}>Показать еще </RedButton>
            </div>
          )}
        </div>
        <div
          css={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 16,
            marginBottom: '4rem',
            marginTop: '4rem',
            [DEVICE_SCREENS_MAX_STRING.xl]: {
              gridTemplateColumns: '1fr',
              marginBottom: '2rem',
              marginTop: '2rem',
            },
          }}
        >
          <Subscription currentCity={currentCity} />
          <MobileApps />
        </div>
      </main>
    </Container>
  );
}
